<ng-container *ngIf="entity">
    <ng-container *ngIf="(readOnly && isRecordDefined) || !readOnly">
        <div class="w-full" [ngClass]="{ 'flex flex-wrap items-baseline': !readOnly }">
            <!-- This container is for business keys -->
            <ng-container *ngFor="let field of record.fields; trackBy: trackByFieldId">
                <ng-container *ngIf="field.isBusinessKey && field.show !== false">
                    <ng-container
                        *ngTemplateOutlet="
                            field.uiTypeMetadata === 'TEXTAREA' ? richTextEditor : recordInput;
                            context: { field: field, enableField: !record.readOnly && !field.disabled, record: record }
                        "></ng-container>
                </ng-container>
            </ng-container>
        </div>
        <div class="w-full" *ngIf="!showOnlyBusinessKeyFields" [ngClass]="{ 'flex flex-wrap items-baseline': !readOnly }">
            <!-- This container is for non business keys -->
            <ng-container [ngSwitch]="readOnly">
                <ng-container *ngSwitchCase="true">
                    <ng-container
                        *ngTemplateOutlet="
                            readOnlyGroups && readOnlyGroups.length > 0 ? recordFieldGroups : recordFieldsNonGrouped;
                            context: { record: record, groups: readOnlyGroups }
                        "></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                    <ng-container
                        *ngTemplateOutlet="
                            groups && groups.length > 0 ? recordFieldGroups : recordFieldsNonGrouped;
                            context: { record: record, groups: groups }
                        "></ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="readOnly && !isRecordDefined && !showOnlyBusinessKeyFields">
        <div class="w-full h-full flex items-center justify-center text-center" *transloco="let translate">
            <div class="items-center text-center">
                <span [textContent]="translate('No data found')"></span>
                <material-button
                    *ngIf="!inAuditTrailMode && hasEditPermission"
                    class="relative top-[10px] right-[10px]"
                    [buttonType]="'raised'"
                    [classList]="['!text-[#00a651]']"
                    (buttonClicked)="editRecord.emit()"
                    [disabled]="isEntityReadonly"
                    [text]="translate('Add Data')"></material-button>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #recordFieldGroups let-record="record" let-groups="groups">
    <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
        <div class="groupedFields block w-full">
            <div
                class="groupedFieldsHeader bg-[#efefef] w-full my-[10px] font-weight-[700] font-size-[14px]"
                *ngIf="group && group.length > 0">
                <span [textContent]="group"></span>
            </div>
            <div class="groupedFieldsBody mt-2 w-full" [ngClass]="{ 'flex flex-wrap items-baseline': !readOnly }">
                <ng-container *ngFor="let field of record.fields | FieldsGroup : group; trackBy: trackByFieldId">
                    <ng-container [ngSwitch]="field.inAudit">
                        <ng-container *ngSwitchCase="true">
                            <ng-container *ngIf="!field.isBusinessKey">
                                <ng-container
                                    *ngTemplateOutlet="
                                        field.uiTypeMetadata === 'TEXTAREA' ? richTextEditor : recordInput;
                                        context: { field: field, enableField: !record.readOnly && !field.disabled, record: record }
                                    "></ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="!field.isBusinessKey">
                                <ng-container
                                    *ngTemplateOutlet="
                                        field.uiTypeMetadata === 'TEXTAREA' ? richTextEditor : recordInput;
                                        context: { field: field, enableField: !record.readOnly && !field.disabled, record: record }
                                    "></ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #recordFieldsNonGrouped let-record="record">
    <div>
        <ng-container *ngFor="let field of record.fields; trackBy: trackByFieldId">
            <ng-container *ngIf="!field.isBusinessKey && field.show !== false">
                <ng-container
                    *ngTemplateOutlet="
                        field.uiTypeMetadata === 'TEXTAREA' ? richTextEditor : recordInput;
                        context: { field: field, enableField: !record.readOnly && !field.disabled, record: record }
                    "></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #richTextEditor let-field="field" let-enableField="enableField" let-record="record">
    <div
        class="w-full p-2.5"
        [ngClass]="{
            'pl-3.5':
                !inputDisabled &&
                enableField &&
                field.preCaptureType !== 'SETUP' &&
                field.preCaptureType !== 'FILING' &&
                !field.readOnly &&
                !readOnly
        }"
        *ngIf="isFieldShown(field) && !field.autoCalculate"
        [class.highlightField]="fieldsToHighlight.indexOf(field.id) > -1">
        <div class="-mb-3 text-[#9f9f9f] flex items-center gap-1">
            <span [textContent]="field.displayName"></span>
            <span
                class="material-symbols-outlined !text-[20px] !w-[16px] !h-[16px] !leading-[14px] cursor-pointer"
                *ngIf="field.description?.length > 0"
                [matTooltip]="field.description"
                matTooltipClass="large-tooltip"
                matTooltipPosition="after">
                info
            </span>
        </div>
        <ng-container *ngTemplateOutlet="readOnly ? plainContent : editor"></ng-container>
        <ng-template #plainContent>
            <div
                class="p-3 angular-editor-textarea plain-text"
                [title]="decodeTextFieldValue(field.value, true)"
                [innerHTML]="decodeTextFieldValue(field.value)"></div>
        </ng-template>
        <ng-template #editor>
            <app-rich-text-editor
                [id]="field.id"
                [enableEncryptDecrypt]="true"
                [placeholder]="field.description?.length > 0 ? field.description : field.displayName"
                [model]="field.value"
                [required]="field.isMandatory || field.isBusinessKey"
                [editable]="
                    !inputDisabled &&
                    enableField &&
                    field.preCaptureType !== 'SETUP' &&
                    field.preCaptureType !== 'FILING' &&
                    !field.readOnly &&
                    !readOnly
                "
                [errors]="field.message.errors"
                (modelChange)="field.value = $event"></app-rich-text-editor>
        </ng-template>
    </div>
</ng-template>

<ng-template #recordInput let-field="field" let-enableField="enableField" let-record="record">
    <div
        class="w-full text-[#565656]"
        [ngClass]="{ '!w-[25%] px-2': !readOnly && field?.uiType !== 'RADIOBUTTON' }"
        *ngIf="isFieldShown(field) && (readOnly || (!readOnly && !field.autoCalculate))"
        [class.highlightField]="fieldsToHighlight.indexOf(field.id) > -1">
        <ng-container [ngSwitch]="readOnly">
            <ng-container *ngSwitchCase="true">
                <div class="h-[24px] leading-[24px] flex items-center my-1">
                    <div class="w-[30%] truncate h-[24px] leading-[24px] !text-[#9f9f9f]" [matTooltip]="field.displayName || field.name">
                        <span [textContent]="field.displayName || field.name"></span>
                        <mat-icon class="rotate-45 text-[16px] !w-[20px] !h-[20px] align-middle" *ngIf="field.isBusinessKey">
                            vpn_key
                        </mat-icon>
                        <span
                            class="material-symbols-outlined !text-[16px] !w-[20px] !h-[20px] cursor-help align-middle"
                            *ngIf="field.description?.length > 0"
                            [matTooltip]="field.description">
                            info
                        </span>
                    </div>
                    <ng-container [ngSwitch]="field.inAudit">
                        <ng-container *ngSwitchCase="true">
                            <div class="auditValueContainer flex" [class.recordDeleted]="!record.active">
                                <div class="oldValueContainer flex" [hidden]="field.oldValue === ''">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            readOnlyValueTemplate;
                                            context: { field: field, value: field.oldValue, isOldValue: true}
                                        "></ng-container>
                                </div>
                                <div class="newValueContainer flex">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            readOnlyValueTemplate;
                                            context: { field: field, value: field.newValue, isNewValue: true }
                                        "></ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container
                                *ngTemplateOutlet="
                                    readOnlyValueTemplate;
                                    context: { field: field, value: field.originalValue }
                                "></ng-container>
                        </ng-container>
                    </ng-container>
                </div>
                <ng-container *ngIf="record?.fields?.length === 1 && field.datatype === 'ATTACHMENT' && field.originalValue?.length > 0">
                    <app-attachment-file-view [fileUrl]="field?.originalValue?.[0]"></app-attachment-file-view>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <lib-field-input
                    [instanceId]="instanceId"
                    [field]="field"
                    [enableField]="
                        !inputDisabled &&
                        enableField &&
                        field.preCaptureType !== 'SETUP' &&
                        field.preCaptureType !== 'FILING' &&
                        field.readOnly !== true
                    "
                    [record]="record"
                    [service]="service"
                    [masterEntityFieldValueMap]="masterEntityFieldValueMap"
                    [fieldsMap]="fieldsMap"
                    [recordUpdateDisabled]="recordUpdateDisabled"
                    [recordIds]="recordIds"
                    [parentRecordId]="parentRecordId"
                    (recordUpdated)="recordUpdated.emit($event)"
                    (getRecord)="getRecord.emit()"
                    (modelChange)="inputModelChange($event, record, field)"></lib-field-input>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #readOnlyValueTemplate let-field="field" let-value="value" let-isOldValue="isOldValue" let-isNewValue="isNewValue">
    <span *ngIf="!isNewValue" [ngClass]="{'w-[2%]': !(isOldValue || isNewValue), 'relative right-[4px]': isOldValue}">:</span>
    <ng-container [ngSwitch]="field.datatype">
        <ng-container *ngSwitchCase="'ATTACHMENT'">
            <div class="w-[69%] flex items-center truncate" *ngIf="value">
                <ng-container [ngSwitch]="value !== undefined">
                    <ng-container *ngSwitchCase="true">
                        <span class="readOnlyAttachmentIcon" *transloco="let translate">
                            <mat-icon [title]="translate('Download files')" (click)="openAttachModal(field)">attach_file</mat-icon>
                        </span>
                        <ng-container *ngFor="let file of value; let i = index; trackBy: trackByFile">
                            <span class="fieldFileName" [title]="file.substring(file.lastIndexOf('/') + 1)">
                                <ng-container [ngSwitch]="file.indexOf('http://') > -1 || file.indexOf('https://') > -1">
                                    <a *ngSwitchCase="true" [href]="file" target="_blank">
                                        <span [textContent]="file.substring(file.lastIndexOf('/') + 1)"></span>
                                    </a>
                                    <a *ngSwitchDefault [href]="attachmentUri + file" target="_blank">
                                        <span [textContent]="file.substring(file.lastIndexOf('/') + 1)"></span>
                                    </a>
                                </ng-container>
                            </span>
                            <ng-container *ngIf="value[i + 1]">,</ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>'--'</ng-container>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'INT'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'LONG'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'DOUBLE'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'DECIMAL'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'FLOAT'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'DATE'">
            <div [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}" [title]="value !== undefined ? value : '--'">
                <span [textContent]="value !== undefined ? value : '--'"></span>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'GRID'">
            <span [ngClass]="{'w-[69%]': !(isOldValue || isNewValue),'line-through px-4': isOldValue}">
                <grid-field [field]="field" [readOnly]="true" [hideDisplayNameData]="true"></grid-field>
            </span>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container [ngSwitch]="value !== undefined && field.uiTypeMetadata">
                <ng-container *ngSwitchCase="'PASSWORD'">
                    <div class="readOnlyValue w-[69%] readOnlyPasswordValue">*******</div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div [dir]="field.textDirection" [ngClass]="{'w-[69%] truncate': !(isOldValue || isNewValue),'line-through px-4': isOldValue}" [title]="value !== undefined ? value : '--'">
                        <span [textContent]="value !== undefined ? value : '--'"></span>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>
